import { styled } from "@mui/material";
import { detailRowName } from "../classes.js";
const IconContainer = styled("div", {
  name: detailRowName,
  slot: "Icon",
  overridesResolver: (_props, styles) => styles.icon
})(({ ownerState, theme }) => ({
  ...ownerState.iconSize === "small" && {
    fontSize: theme.typography.fontSize * 1
  },
  ...ownerState.iconSize === "medium" && {
    fontSize: Math.trunc(theme.typography.fontSize * 1.15)
  },
  ...ownerState.iconSize === "large" && {
    fontSize: theme.typography.fontSize * 1.5
  }
}));
export {
  IconContainer
};
//# sourceMappingURL=IconContainer.js.map
